import { render, staticRenderFns } from "./SideTagsSummary.vue?vue&type=template&id=df77cb86&scoped=true&"
import script from "./SideTagsSummary.vue?vue&type=script&lang=js&"
export * from "./SideTagsSummary.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsSummary.vue?vue&type=style&index=0&id=df77cb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df77cb86",
  null
  
)

export default component.exports